/**
 * Sets one localStorage item by key.
 * @param {string} key
 * @param {string|number|boolean|null} value
 * @returns {void}
 */
export const setToLocalStorage = (key, value) => {
  if (!key) return;
  localStorage.setItem(key, value);
};

/**
 * Removes one localStorage item by key.
 * @param {string} key
 * @returns {void}
 */
export const removerFromLocalStorage = (key) => {
  if (!key) return;
  localStorage.removeItem(key);
};

/**
 * Sets multiple localStorage items from key-value entries.
 * @param {Record<string, string|number|boolean|null>} entries
 * @returns {void}
 */
export const setManyToLocalStorage = (entries = {}) => {
  Object.entries(entries).forEach(([key, value]) => {
    setToLocalStorage(key, value);
  });
};

/**
 * Removes multiple localStorage items by keys.
 * @param {string[]} keys
 * @returns {void}
 */
export const removeManyFromLocalStorage = (keys = []) => {
  keys.forEach((key) => {
    removerFromLocalStorage(key);
  });
};
